<script>
export default {
  data() {
    return {
      tableData: [],
      defaultValue: {},
      addingRegion: false,
      deleteRegion: false,
      formInputArray: [
        {
          label: "大区名称",
          keyName: "regionName",
          type: "text"
        },
        {
          label: "大区经理",
          keyName: "managerId",
          type: "select",
          children: []
        }
      ],
      buttonArray: [
        {
          text: "删除大区",
          key: "remove"
        }
      ]
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let data = await this.$http.AdminRegionList();
      if (data) {
        let newTableData = [];
        data.forEach(item => {
          newTableData.push({
            regionName: item.region.regionName,
            regionManager: item.region.manager ? item.region.manager.name : "",
            region: item.provinceNames.join(","),
            regionId: item.region.id
          });
        });
        this.tableData = newTableData;
      }
    },
    async onSubmit(from) {
      const updateData = {
        regionName: from.regionName,
        managerId: from.managerId
      };
      let data = await this.$http.AdminManagementRegion(updateData, "add");
      if (data === "success") {
        this.loadData();
      }
    },
    onClick(row, event, column) {
      this.$router.push({
        path: `${this.$route.path}/rangeManagementDetail/${row.regionId}`
      });
    },
    async onAddRegion() {
      let data = await this.$http.getManagerList();
      if (data && data.content) {
        let children = [];
        data.content.forEach(o => {
          children.push({
            keyName: o.content.id,
            label: o.content.name
          });
        });
        this.formInputArray[1].children = children;
      }
      this.addingRegion = true;
    },
    async onUpdateRegion(formdata, type, row) {
      if (type === "deleteRegion") {
        const updateData = {
          regionId: row.regionId
        };
        let data = await this.$http.AdminManagementRegion(updateData, "remove");
        if (data === "success") {
          this.loadData();
        }
      }
      this.defaultValue = {};
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      this.deleteRegion = true;
    },
    onClickCancel(key) {
      this.defaultValue = {};
      this.deleteRegion = false;
    }
  }
};
</script>
<template>
  <div class="rangeManagementIndex">
    <el-card class="box-card" shadow="never">
      <div class="text item">
        <DialogForm
          v-if="addingRegion"
          formTitle="添加大区"
          :formInputArray="formInputArray"
          @close="addingRegion = false"
          @submitForm="onSubmit"
        />
        <elementButton class="addBtn" size="medium" @click="onAddRegion">添加大区</elementButton>
        <DialogForm
          v-if="deleteRegion"
          :defaultValue="defaultValue"
          formTitle="请确认删除大区"
          @close="onClickCancel"
          @submitForm="onUpdateRegion"
          keyOperation="deleteRegion"
          confirmButton="确认"
        />
        <el-table
          :data="tableData"
          @row-click="onClick"
          class="accountTable"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="regionName" align="left" label="大区名称" width="180"></el-table-column>
          <el-table-column prop="regionManager" align="left" label="大区经理" width="180"></el-table-column>
          <el-table-column prop="region" align="left" label="管理范围"></el-table-column>
          <el-table-column prop="operation" align="left" label="操作" width="180">
            <template slot-scope="scope">
              <textButtonGroup
                :buttonArray="buttonArray"
                :rowData="scope.row"
                @onOperationClick="onOperationClick"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.rangeManagementIndex {
  .addBtn {
    width: 83px;
    height: 33px;
    margin-top: 20px;
    border-radius: 3px;
    float: right;
    margin-right: 3%;
    padding: 3px;
    margin-bottom: 20px;
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .box-card {
    // width: 480px;
  }

  .accountTable {
    margin: 20px auto;
    border: 1px;
    width: 96%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rangeManagement/index.vue